module.exports = __webpack_public_path__ + "img/4.1a423863.jpg";